module.exports = __webpack_public_path__ + "static/media/img-find-us-riyadh-l@3x.057f1669.png";